import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

import { EdpEsWidgetOrderComponent } from "./edp-es-widget-order.component";
import { EdpEsOrderStepsComponent } from "./components/edp-es-order-steps/edp-es-order-steps.component";
import { RouterModule } from "@angular/router";
import { EdpPipesModule } from "src/app/@pipes/edp-pipes.module";

@NgModule({
    declarations: [EdpEsWidgetOrderComponent, EdpEsOrderStepsComponent],
    imports: [CommonModule, TranslateModule, RouterModule, EdpPipesModule],
    exports: [EdpEsWidgetOrderComponent, EdpEsOrderStepsComponent],
})
export class EdpEsWidgetOrderModule {}
